<template>
	<div class="aui-wrapper aui-page__login" :style="{
		'background-image':`url(${bgImgUrl})`,
		'backgroundSize':'100% 100%'
	}">
		<div class="aui-content__wrapper">
			<main class="aui-content">
				<div class="login-body">

						<h2 class="login-brand" style="padding-bottom: 30px;font-size: 50px;font-weight:bold;color:#fff">
							<img width="300px" :src="logoImg" class="logo" />
						</h2>
					<!-- <h3 class="login-title">{{ $t('login.title') }}</h3> -->
					<el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
					 status-icon>
						<!-- <el-form-item>
              <el-select v-model="$i18n.locale" class="w-percent-100">
                <el-option v-for="(val, key) in i18nMessages" :key="key" :label="val._lang" :value="key"></el-option>
              </el-select>
            </el-form-item> -->
						<el-form-item prop="username">
							<el-input v-model="dataForm.username" :placeholder="$t('login.username')" style="font-size:16px;">
								<span slot="prefix" class="el-input__icon">
									<img :src="userImg" style="margin-left: 38px;" />
									<!-- <svg class="icon-svg" aria-hidden="true"><use xlink:href="#icon-user"></use></svg> -->
								</span>
							</el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input v-model="dataForm.password" type="password" show-password :placeholder="$t('login.password')" style="font-size:16px;">
								<span slot="prefix" class="el-input__icon">
									<img :src="passwordImg" style="margin-left: 38px;" />
									<!-- <svg class="icon-svg" aria-hidden="true"><use xlink:href="#icon-lock"></use></svg> -->
								</span>
							</el-input>
						</el-form-item>
						
						<el-form-item prop="captcha" v-show="true">
							<el-row :gutter="20">
								<el-col :span="14">
									<el-input v-model="dataForm.captcha" :placeholder="$t('login.captcha')" style="font-size:16px;">
										<span slot="prefix" class="el-input__icon">
											<svg class="icon-svg" aria-hidden="true">
												<use xlink:href="#icon-safetycertificate"></use>
											</svg>
										</span>
									</el-input>
								</el-col>
								<el-col :span="10" class="login-captcha">
									<img :src="captchaPath" @click="getCaptcha()">
								</el-col>
							</el-row>
						</el-form-item>
						 <el-form-item>							 
						<!-- 	<div @click="dataRegist()" stype="" class="regist">注册新账户</div> -->
							<div @click="UpdatePws()" class="updataPws">忘记密码</div>
						</el-form-item>

						<!-- 验证码 -->
						<el-form-item prop="code" label="" v-show="isYzmVisabled">
							<el-input class="codeInput" style="width: 225px;margin-right: 15px;padding-left:0;font-size:16px;" placeholder="手机验证码" v-model="dataForm.code">
								<span slot="prefix" class="el-input__icon">
									<i class="el-icon-chat-line-round"></i>
								</span>
							</el-input>
							<el-button type="info" style="width: 150px;height: 50px;line-height: 50px;border-radius: 14px;padding: 0;" @click="sendCode" v-show="isShow" :disabled="dataForm.username && dataForm.password && dataForm.captcha ? false : true">发送验证码</el-button>
							<el-button type="info" :disabled="false" v-show="!isShow" style="padding: 0;width: 150px;height: 50px;line-height: 50px;border-radius: 14px;background-color: lightgrey">{{secondsCount}}秒后重发</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="dataFormSubmitHandle()" :loading="loadingbut" class="loginBtn" style="font-size:20px;">{{ $t('login.title') }}</el-button>
						</el-form-item>
						<el-form-item prop="optionCheck" label-width="30px" style="text-align: left;">
							<el-checkbox-group v-model="dataForm.optionCheck" style="display: inline-block;height:20px">
								<el-checkbox label="协议" style="margin:0 0 20px 0;" name="type">我已阅读并同意</el-checkbox>
							</el-checkbox-group>
							<span @click="dialogVisible = true" style="cursor: pointer;">《平台服务协议、隐私保护政策》</span>
						</el-form-item>
					</el-form>
				</div>
				<div class="login-footer">

				</div>
				<el-dialog :show-close="false" top="6vh" width="1056px" title="平台服务协议及用户隐私保护政策" :visible="dialogVisible">
					<div style="font-size: 12px;color: #333;text-align: left;height: 640px;overflow-y: scroll;padding-right:10px;" class="xieyi">
						<p>财天下共享经济服务平台（“我们”）非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《隐私政策》（“本隐私政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。</p>
						<p>本隐私政策与您所使用的财天下共享经济服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。</p>
						
						
							<h2>一、适用范围</h2>
							<p style="text-indent:0;padding-left:20px;">1、本隐私权政策适用于财天下共享经济服务平台所有服务，包括向您提供页面浏览、网站登录服务，以及通过财天下共享经济服务平台向您提供的技术服务。<br/>
							2、本隐私权政策不适用于其他第三方通过财天下共享经济服务平台网站向您提供的服务。<br />
							3、需要特别说明的是，作为财天下共享经济服务平台的用户，若您利用财天下共享经济服务平台的技术服务，为您的用户再行提供服务，因您的业务数据属于您所有，您应当另行与您的用户约定相应的隐私政策。</p>
							<h2>二、我们收集您的信息的范围</h2>
							<p style="text-indent:0;padding-left:20px;">本隐私政策中涉及的个人信息包括：<br />
							基本信息：您为完成财天下共享经济服务平台账户的注册、管理、实名认证等，您提交的真实、合法、有效的个人姓名、联系地址、联系电话号码、电子邮箱；<br />
							个人身份信息：您使用财天下共享经济服务平台服务时，您提交身份证、护照等；<br />
							网络身份标识信息：包括系统账号、密码、IP地址、邮箱地址；<br />
							个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私政策中涉及的个人敏感信息包括：<br />
							个人身份信息（包括身份证、护照）；<br />
							网络身份识别信息（包括账户名、邮箱地址及与前述有关的密码）；<br />
							其他信息（包括个人电话号码、手机号码、网页浏览记录）。</p>
							<h2>三、 您可选择是否授权我们收集和使用您的个人信息的情形</h2>
							<p style="text-indent:0;padding-left:20px;">如果您不提供这些个人信息，您依然可以进行浏览我们的产品及/或服务，但您可能无法使用我们的产品及/或服务，主要包括：<br />
							1、不提供手机号码，将无法进行账号注册；无法执行部分需要通过手机验证码以确认用户身份的操作，如找回密码。<br />
							2、不进行实名认证（个人实名认证需要提供姓名、身份证号、银行账号；企业实名认证需要提供营业执照信息及照片、对公银行账号、法人姓名和身份证号及照片），无法购买和使用我们的产品及/或服务。</p>
							<h2>四、 我们收集您的信息的方式</h2>
							<p style="text-indent:0;padding-left:20px;"><span style="font-weight:bold;">一、您申请成为财天下共享经济服务平台用户。</span><br />
							1、当您在财天下共享经济服务平台创建账户时，我们通过您主动提交的您在中华人民共和国境内的手机号码，以及您设置的账号。<br />
							2、在您注册完成财天下共享经济服务平台账户后，您可以在账户“用户中心”一栏中继续填写您的信息，包括（1）您的用户身份类型（个人、企业）、单位名称（如果您已完成实名认证，单位名称将会以您的实名认证信息为准）、主营业务，（2）联系信息（所在地区）。您若不提供这些信息，将不会影响您对某一服务的使用。<br />
							3、在您注册完成财天下共享经济服务平台账户后，您可在账号的管理控制台提交联系人信息，包括您指定联系人的邮箱、手机号码。财天下共享经济服务平台将通过如上信息向您发送业务通知或与您进行业务沟通。<br />
							4、如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的会员及提供上述信息。<br />
							<span style="font-weight:bold;">二、您使用财天下共享经济服务平台服务</span><br />
							1、在您使用财天下共享经济服务平台的服务时，您通过您的账号提供您的真实身份信息以完成实名认证，在此过程中，您将提交您的姓名（单位主体名称）、身份证号码（营业执照号码）、企业注册地区、企业性质、企业名称和营业执照注册号，企业授权人信息以及银行账户信息（包括开户行、银行账号）。<br />
							2、您使用我们的服务后，我们还将根据您的需要，根据您提供的收件人的姓名、联系方式、收件地址，为您寄送合同及/或发票等。<br />
							3、当您使用我们的网站或客户端提供的服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。<br />
							4、用户账户的支持信息：基于您使用财天下共享经济服务平台服务而产生的用户的咨询记录、报障记录和针对用户故障的排障过程（如通信或通话记录），财天下共享经济服务平台将通过记录、分析这些信息以便更及时响应您的帮助请求，以及用于改进服务。<br />
							<span style="font-weight:bold;">三、我们可能会通过 Cookies 和其他相关技术收集和使用您的信息。</span><br />
							1、我们使用 Cookies 的具体用途包括： 记住您的身份。例如：Cookies 有助于我们辨认您作为我们的注册用户的身份。 分析您使用我们服务的情况，以便为您提供更加周到的个性化服务，包括定制化页面、推荐等服务。<br />
							2、您可以通过浏览器设置拒绝或管理 Cookies。但请注意，如果停用 Cookies，您有可能无法享受最佳的服务体验，某些功能的可用性可能会受到影响。<br />
							3、通过财天下共享经济服务平台 Cookies 记录的有关信息，将适用本隐私声明。<br />
							4、当您终止使用我们的产品与/或服务时，或您使用我们的产品与/或服务之服务期届满后，我们将立即停止继续收集您的个人信息。 </p>
						</p>
					</div>
					<div slot="footer" class="dialog-footer">
					  <el-button style="color: #409eff;" type="text" @click="dataForm.optionCheck=[];dialogVisible = false">不同意</el-button>
					  <el-button style="background-color: #409eff;border: none;" type="primary" @click="doRead">我同意</el-button>
					</div>
				</el-dialog>
			</main>
		</div>
		<div style="width:100%;margin:0 auto;display: flex;align-items: center; justify-content: center; position: fixed;text-align: center;
		bottom: 10px;color: #fff;">
			<a href="https://beian.miit.gov.cn" style="position: absolute;left: 0;top: 22.5px;color: #fff" >京ICP备20006561号-1</a>
			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202009055" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
				<img :src='require("../../assets/img/icon.png")' style="float:left;"/>
				<p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#fff;">京公网安备 <span style="text-decoration: underline;">11010202009055</span>号</p>
			</a>
		</div>
	</div>
</template>

<script>
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
import aesJs from '../../utils/login-aes'
import {
  messages
} from '@/i18n'
import {
  getUUID
} from '@/utils'
export default {
  data () {
    return {
		isYzmVisabled:false,
		secondsCount: 0, // 倒计秒数初始化定义
		isShow: true, // 是否显示发送验证码按钮
		bgIndex:1,
		// imgUrlList:[
		// 	`${require('../../assets/img/login/01.jpg')}`,
		// 	`${require('../../assets/img/login/02.jpg')}`,
		// 	`${require('../../assets/img/login/03.jpg')}`,
		// 	`${require('../../assets/img/login/04.jpg')}`,
		// 	`${require('../../assets/img/login/05.jpg')}`,
		// ],
		bgImgUrl:require('../../assets/img/login/04.jpg'),
      i18nMessages: messages,
      logoImg: require('../../assets/img/qiye_logo.png'),
      userImg: require('../../assets/img/user.png'),
      passwordImg: require('../../assets/img/password.png'),
      captchaPath: '',
      dataForm: {
        username: '',
        password: '',
        uuid: '',
        captcha: '',
        grant_type: 'password',
        optionCheck: [],
		code:''
      },
      dialogVisible: false,
      loadingbut: false
    }
  },
  computed: {
    dataRule () {
      return {
        username: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
		code: [{
          required: false,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
		captcha: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        optionCheck: [{
          type: 'array',
          required: true,
          message: '请勾选我已详细阅读并同意',
          trigger: 'change'
        }]
      }
    }
  },
  created () {
	this.getYzmVis();
    this.getCaptcha()
  },
  methods: {
	sendCode () {
		// this.dataForm.uuid = getUUID()
		let nPassw = aesJs.encrypt(this.dataForm.password)
        // 发送短信验证
        this.$http.post('/sys/user/sendCodeWithPassword', { 
			username: this.dataForm.username,
			password:nPassw,
			captcha:this.dataForm.captcha,
			uuid:this.dataForm.uuid
		}, {
          headers: {
            'content-type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          // 倒计时
          if (res.data && res.data.code == 0) {
            let that = this
            console.log(that)
            that.secondsCount = 60
            // 切换倒计时按钮
            that.isShow = false
            // 倒计时函数
            let timer = setInterval(function () {
				that.secondsCount--
				if (that.secondsCount <= 0) {
					clearInterval(timer)
					that.isShow = true
				}
            }, 1000)
          } else {
            this.getCaptcha()
            this.$message.error(res.data.msg)
          }
        })
    },
	getYzmVis(){
		this.$http.get(`/sys/params/getResultByCode/isRequireSMSVerification?resultType=1`,{}).then((res) => {
			if(res.data.data == '1'){
				this.isYzmVisabled =  true;
			}
		})
	},
    // 获取验证码
    getCaptcha () {
		this.dataForm.uuid = getUUID()
		this.captchaPath = `${window.SITE_CONFIG['apiURL']}/auth/captcha?uuid=${this.dataForm.uuid}`
	//   setInterval(() => {
	// 	if(this.bgIndex == 4){
	// 		this.bgIndex = 0
	// 	}else{
	// 		this.bgIndex++
	// 	}
	// 	this.bgImgUrl = this.imgUrlList[this.bgIndex]
	//   },3000)
	  
    },
    // 注册
    dataRegist () {
      this.$router.push({
        path: '/registpage'
      })
    },
    // 忘记密码
    UpdatePws () {
      this.$router.push({
        path: '/updatePwd'
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.loadingbut = true
        let paramsForm = JSON.parse(JSON.stringify(this.dataForm));
		    paramsForm.password = aesJs.encrypt(paramsForm.password)
        this.$http.post('/auth/oauth/token', paramsForm, {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic cmVucmVuaW86cmVucmVuaW8='
          }
        }).then(({
          data: res
        }) => {
          this.loadingbut = false
          if (res.code !== 0) {
            this.getCaptcha()
            return this.$message.error(res.msg)
          }
          Cookies.set('access_token', res.access_token)
          this.$router.push({
            name: 'home'
          }).catch(() => {})
        })
      })
    }, 1000, {
      'leading': true,
      'trailing': false
    }),
    doRead () {
      this.dataForm.optionCheck[0] ? this.dataForm.optionCheck[0] = '协议' : this.dataForm.optionCheck.push('协议')
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped lang="scss">
.el-row{
	display: flex;
	align-items: center;
}
.login-captcha{
	height: 100%;
}
/deep/ .el-dialog__body{
	padding-top: 0px !important;
}
/deep/ .el-dialog__header{
	padding:20px 0 !important;
	font-weight: bold;
	height: 60px !important;
}
.xieyi p{
	text-indent:2em;
	line-height: 20px;
	margin:10px 0;
	color:#000;
	font-size: 13px;
}
h2{
	font-weight: bold;
}
.login-body{
	background: #fff;
	padding:20px 50px;
	padding-bottom: 20px;
	// transform:scale(.8);
    border-radius: 10px;
	background: rgba(255,255,255,.8);
}
</style>
